<template>
  <main data-layout="auth">
    <aside>
      <logo></logo>
      <article>
        <h3>{{ $t("auth-planetx-about-title") }}</h3>
        <p>{{ $t("auth-planetx-about-description") }}</p>
      </article>
      <article>
        <h3>{{ $t("auth-planetfx-about-title") }}</h3>
        <p>{{ $t("auth-planetfx-about-description") }}</p>
      </article>
    </aside>
    <section>
      <form>
        <div class="btn-group">
          <router-link
            tag="button"
            :to="{ name: 'login', params: { tabName: 'LoginForm' } }"
            type="button"
            :class="[tabName === 'login' ? 'primary' : 'default']"
            >{{ $t("auth-form-login") }}
          </router-link>
          <router-link
            tag="button"
            :to="{ name: 'register', params: { tabName: 'RegisterForm' } }"
            type="button"
            :class="[tabName === 'register' ? 'primary' : 'default']"
            >{{ $t("auth-form-register") }}
          </router-link>
        </div>
        <router-view />
      </form>
      <footer>
        <a
          v-for="lang in languages"
          :key="lang.title"
          @click="changeLocale(lang.language)"
          :class="{ active: lang.language === locale }"
        >
          {{ lang.title }}
        </a>
      </footer>
    </section>
  </main>
</template>

<script>
import { mapState } from "vuex";
import { changeLocale } from "@/mixins/localeMixin";
import Logo from "@/components/Logo";
import Base from "@/views/modules/base/Index";

export default {
  extends: Base,
  name: "Auth",
  mixins: [changeLocale],
  components: {
    Logo
  },
  computed: {
    ...mapState("common", ["languages"]),
    tabName() {
      return this.$route.name;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/variables";

main[data-layout="auth"] {
  display: flex;
  height: 100vh;
  min-height: 800px;
}
section {
  width: 70%;
  max-width: 600px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  form {
    flex: 2;
    display: flex;
    flex-direction: column;
    margin-top: 70px;
    /deep/ .form-group {
      margin-top: 25px;
    }
    .btn-group {
      margin: 40px 0;
    }
    /deep/ button[type="submit"] {
      width: 100%;
    }
  }
  footer {
    a {
      color: inherit;
      &.active {
        color: $primary;
      }
      &:not(:last-child):after {
        content: "|";
        display: inline;
        color: $middle-gray;
        padding: 0 10px;
      }
    }
  }
}
aside {
  width: 30%;
  max-width: 400px;
  background: $light-gray;
  box-shadow: inset -6px 0 5px -5px rgba(0, 0, 0, 0.15);
  article {
    margin-top: 50px;
  }
  p {
    color: #81869e;
  }
}

section,
aside {
  padding: 30px;
}
</style>
